import {ErrorHandler, Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable()
export class FlyErrorHandler extends ErrorHandler {
	constructor() {
		super();
	}

	private _currentError = new BehaviorSubject<any>(null);

	get currentError(): Observable<any> {
		return this._currentError.asObservable();
	}

	clearError() {
		this._currentError.next(null);
	}

	handleError(error: any) {
		this._currentError.next(error);
		super.handleError(error);
	}
}
